import { FronteggContext } from '@frontegg/rest-api';
import { axios } from 'src/lib/axios';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import {
  questionnaireLoadingSlice,
  questionnaireListSlice,
  questionnaireItemSlice,
} from '../slices';

export const getQuestionnairesAction = (condition_id = null, onSuccess) => {
  return async (dispatch) => {
    try {
      dispatch(questionnaireLoadingSlice(true));
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await axios.get('/v2/questionnaire', {
        headers,
        params: { condition_id: condition_id || null },
      });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(questionnaireListSlice(response?.questionnaires));
      }
      if (onSuccess) onSuccess();
    } catch (error) {
      showToastError(error);
    } finally {
      dispatch(questionnaireLoadingSlice(false));
    }
  };
};

export const getQuestionnaireByIdAction = (id, onSuccess) => {
  return async (dispatch) => {
    try {
      dispatch(questionnaireLoadingSlice(true));
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await axios.get(`/v2/questionnaire/${id}`, {
        headers,
      });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(questionnaireItemSlice(response));
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      showToastError(error);
    } finally {
      dispatch(questionnaireLoadingSlice(false));
    }
  };
};

export const updateQuestionnaireAction = (id, payload, onSuccess) => {
  return async (dispatch) => {
    try {
      dispatch(questionnaireLoadingSlice(true));
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await axios.put(`/v2/questionnaire/${id}`, payload, {
        headers,
      });
      const response = result?.data;
      if (result?.status === 200 && response) {
        showToastSuccess('Questionnaire updated successfully');
        dispatch(questionnaireItemSlice(response));
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      showToastError(error);
    } finally {
      dispatch(questionnaireLoadingSlice(false));
    }
  };
};

export const deleteQuestionnaireAction = (id, onSuccess) => {
  return async (dispatch) => {
    try {
      dispatch(questionnaireLoadingSlice(true));
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await axios.delete(`/v2/questionnaire/${id}`, {
        headers,
      });
      if (result?.status === 200 || result?.status === 204) {
        showToastSuccess('Questionnaire deleted successfully');
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      showToastError(error);
    } finally {
      dispatch(questionnaireLoadingSlice(false));
    }
  };
};

export const createQuestionnaireAction = (payload, onSuccess) => {
  return async (dispatch) => {
    try {
      dispatch(questionnaireLoadingSlice(true));
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await axios.post('/v2/questionnaire', payload, {
        headers,
      });
      const response = result?.data;
      if (result?.status === 200 || result?.status === 201) {
        showToastSuccess('Questionnaire created successfully');
        dispatch(questionnaireItemSlice(response));
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      showToastError(error);
    } finally {
      dispatch(questionnaireLoadingSlice(false));
    }
  };
};
